export default "__VITE_ASSET__CsSPOgpt__"